/**
 * Utility functions extracted from VennDiagram.tsx
 */

/**
 * Converts a hex color to rgba format
 */
export const hexToRgba = (initialHex: string, opacity = 0.5): string => {
  const hex = initialHex.replace(/^#/, "");
  const normalizedHex =
    hex.length === 3
      ? hex
          .split("")
          .map((char) => char + char)
          .join("")
      : hex;

  const r = parseInt(normalizedHex.substring(0, 2), 16);
  const g = parseInt(normalizedHex.substring(2, 4), 16);
  const b = parseInt(normalizedHex.substring(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

/**
 * Calculates the position for each circle in the Venn diagram
 */
export const calculateCirclePosition = (
  index: number,
  width: number,
  height: number,
  circleRadius: number
): { cx: number; cy: number } => {
  const positions = [
    { cx: width / 2 - circleRadius, cy: height / 2 - circleRadius / 0.75 },
    { cx: width / 2 + circleRadius, cy: height / 2 - circleRadius / 0.75 },
    { cx: width / 2, cy: height / 2 + circleRadius / 4 },
    { cx: width / 2 - circleRadius, cy: height / 2 + circleRadius / 0.55 },
    { cx: width / 2 + circleRadius, cy: height / 2 + circleRadius / 0.55 },
  ];

  return index < positions.length
    ? positions[index]
    : { cx: width / 2, cy: height / 2 };
};
